export const piiCategories = [
  "Social security number",
  "Password",
  "Protected status",
  "Credit card",
  "Race",
  "Birthdate",
  "Phone",
  "Address",
  "Gender",
  "Ethnicity",
  "Country",
  "Name",
  "Street",
  "City",
  "Zip code",
  "Email",
  "Identification",
  "Serial number",
  "IP address",
  "Religion",
  "Medical information",
].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
